/**
 * @module plugins/vuedraggable
 * @description This plugin integrates the vuedraggable library into Nuxt. Currentlu it is used in the question set dialog to reorder questions using drag and drop
 * @param {Object} nuxtApp - The Nuxt app instance.
 * @returns {void} This function does not have a return value, it only registers the Draggable component.
 */

import Draggable from 'vuedraggable'
import {defineNuxtPlugin} from 'nuxt/app'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.component('draggable', Draggable)
})
